// frontend/src/features/ui/filtersSlice.js 
// This Redux slice manages the UI’s driver filters—agency selection, search query, and global-vs-tab scope—exposing actions and selectors to update/read them.
import { createSlice } from '@reduxjs/toolkit';

const initialFilters = { agencyId: '', q: '', scope: 'tab' }; // '' = All Agencies

// ✅ NEW: statsRefreshKey lives alongside filters (UI-only invalidation signal)
const initialState = {
  filters: initialFilters,
  statsRefreshKey: 0,
};

const filtersSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setAgencyId: (state, action) => { state.filters.agencyId = action.payload ?? ''; },
    setQuery:    (state, action) => { state.filters.q        = action.payload ?? ''; },
    setScope:    (state, action) => {
      state.filters.scope = action.payload === 'global' ? 'global' : 'tab';
    },
    reset: (state) => {
      state.filters = initialFilters;
      state.statsRefreshKey = 0; // optional: reset the key too
    },

    // ✅ NEW: bump key to force UpsDriverStats effect to rerun
bumpStatsRefreshKey: (state) => {
  // 🔎 DEBUG LOG (TEMP): prove a bump happened + where it came from
  console.log('[ui] bumpStatsRefreshKey', {
    path: window.location?.pathname,
    before: state.statsRefreshKey,
    after: state.statsRefreshKey + 1,
    at: new Date().toISOString(),
    stack: new Error().stack, // shows call site in console
  });

  state.statsRefreshKey += 1;
},
 },
});

export const {
  setAgencyId,
  setQuery,
  setScope,
  reset,
  bumpStatsRefreshKey, // ✅ NEW export
} = filtersSlice.actions;

// Selectors
export const selectFilters  = (s) => s.ui?.filters ?? initialFilters;
export const selectAgencyId = (s) => s.ui?.filters?.agencyId ?? '';
export const selectQuery    = (s) => s.ui?.filters?.q ?? '';
export const selectScope    = (s) => s.ui?.filters?.scope ?? 'tab';

// ✅ NEW selector
export const selectStatsRefreshKey = (s) => s.ui?.statsRefreshKey ?? 0;

export default filtersSlice.reducer;
